import { OnInit } from '@angular/core';
import { AppState } from './app.service';
import { Auth } from './shared/services/auth';
import { Configuration } from './shared/services/configuration';
import { HttpClientCustom } from './shared/services/http.client';
import * as _ from 'underscore';
import { PermissionHelper } from './shared/permissions/permissions';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './environment';
import '../styles/styles.scss';
var AppComponent = /** @class */ (function () {
    function AppComponent(appState, _auth, _global, _http, _per, translate) {
        this.appState = appState;
        this._auth = _auth;
        this._global = _global;
        this._http = _http;
        this._per = _per;
        this.angularclassLogo = 'assets/img/angularclass-avatar.png';
        this.name = 'Angular 2 Webpack Starter';
        this.url = 'https://twitter.com/AngularClass';
        this.showLoading = false;
        this.loadTabs = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = JSON.parse(localStorage.userInfo);
        if (data.localeName == null) {
            data.localeName = 'en_US';
        }
        document.documentElement.setAttribute('lang', data.localeName);
        translate.setDefaultLang(data.localeName);
        document.title = environment.appTitle;
        document.documentElement.setAttribute('client', environment.client);
    }
    Object.defineProperty(AppComponent.prototype, "isAuthenticated", {
        get: function () {
            return this._auth.isAuthenticated;
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.ngOnInit = function () {
        this.getAllPermission();
    };
    AppComponent.prototype.loader = function (option) {
        this.showLoading = option;
    };
    AppComponent.prototype.getAllPermission = function () {
        var that = this;
        var permission = [];
        if (that.isAuthenticated) {
            var url = that._baseUrl + 'v1/hub/getAdminOperations';
            that._http.get(url).subscribe(function (result) {
                if (result.length > 0) {
                    _.each(result, function (key, val) {
                        if (key.childOperations.length > 0) {
                            permission.push(key.operation);
                            _.each(key.childOperations, function (k, e) {
                                permission.push(k.operation);
                            });
                        }
                    });
                }
                that._per.savePermission(permission);
                that.loadTabs = true;
            });
        }
    };
    AppComponent.prototype.unloadHandler = function (event) {
    };
    AppComponent.prototype.beforeUnloadHander = function (event) {
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// ./src/app/app.component.ts.pre-build-optimizer.js